import type { FeatureCollection } from "geojson";

type GeoEnvelope = { data?: { geojson?: FeatureCollection } };

export function useGeoSource<T extends GeoEnvelope>(opts: {
  data: Ref<T | null | undefined>;
  cacheKey: Ref<string | undefined>;
}) {
  const { cached, read, write } = useStaleWhileRevalidate<T>();

  onMounted(() => {
    const k = opts.cacheKey.value;
    if (k) read(k);
  });

  watch(opts.cacheKey, (k) => {
    cached.value = undefined;
    if (k) read(k);
  });

  watch(opts.data, (fresh) => {
    const k = opts.cacheKey.value;
    if (k && fresh) write(k, fresh);
  });

  const geoMarkers = computed<FeatureCollection>(() => {
    const source = opts.data.value ?? cached.value;
    return source?.data?.geojson ?? { type: "FeatureCollection", features: [] };
  });

  const isShowingCache = computed(() => !opts.data.value && !!cached.value);

  return { geoMarkers, cachedGeo: cached, isShowingCache };
}
